import { useEffect, useState } from 'preact/hooks'
import { SDK_MODAL_TRANSITION_DURATION } from 'scripts/constants'

export default function usdDelayShow(delay?: number, callback?: () => void) {
  const [visible, setVisible] = useState(false)
  useEffect(() => {
    setTimeout(() => {
      setVisible(true)
      callback?.()
    }, delay || SDK_MODAL_TRANSITION_DURATION)
  }, [])
  return {
    visible,
  }
}
